/** @format */
const comps = {}; // ./components下的组件

const modules = import.meta.glob('./*.vue', { eager: true });
for (const path in modules) {
	const cname = path.replace(/(\.\/|\.vue)/g, '');
	comps[cname] = (modules[path] as any).default;
}

const getWidgetName = (type: string) => {
	if (!comps[`${type}`]) {
		throw new Error('没有该类型组件');
	} else {
		return comps[`${type}`];
	}
};

export { getWidgetName };

export default comps;
